/**
 * Асинхронное добавление скрипта
 * @param {String | Array} url
 * @return {Promise}
 */
export function addScript(url) {
  if (Array.isArray(url)) {
    let prom = [];
    url.forEach(function(item) {
      prom.push(addScript(item));
    });
    return Promise.all(prom);
  }

  let script = document.querySelector(`script[src="${url}"]`);
  if (!script) {
    script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;
    script.promise = new Promise((resolve, reject) => {
      script.addEventListener('load', resolve);
      script.addEventListener('error', reject);
    });
    document.body.appendChild(script);
  }
  return script.promise;
}

window.addScript = addScript;
